import GetImageGallery from "../../../../components/Images/GetImageGallery";
import { VACCSPASS } from "../../../../constants";


export default function GetThyroidDocs() {

  return (
       
     <GetImageGallery
        exam_url = { VACCSPASS }
     />
      
    )
    }

